import React from 'react';

const Fronted = () => (
  <div className="skills_content">
    <h2 className="skills_title">
      Frontend Developer
    </h2>

    <div className="skills_box">
      <div className="skills_group">
        <div className="skills_data">
          <i className="bx bx-badge-check" />

          <div>
            <h3 className="skills_name">HTML</h3>
            <span className="skills_level">Advance</span>
          </div>
        </div>
        <div className="skills_data">
          <i className="bx bx-badge-check" />

          <div>
            <h3 className="skills_name"> CSS</h3>
            <span className="skills_level">Advanced</span>
          </div>
        </div>
        <div className="skills_data">
          <i className="bx bx-badge-check" />

          <div>
            <h3 className="skills_name"> Javascript</h3>
            <span className="skills_level">Intermediate</span>
          </div>
        </div>
      </div>
      <div className="skills_group">
        <div className="skills_data">
          <i className="bx bx-badge-check" />

          <div>
            <h3 className="skills_name">Bootstrap</h3>
            <span className="skills_level">Intermediate</span>
          </div>
        </div>
        <div className="skills_data">
          <i className="bx bx-badge-check" />

          <div>
            <h3 className="skills_name">React</h3>
            <span className="skills_level">Intermediate</span>
          </div>
        </div>
        <div className="skills_data">
          <i className="bx bx-badge-check" />

          <div>
            <h3 className="skills_name">Git</h3>
            <span className="skills_level">Intermediate</span>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Fronted;
